module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAMAAACsjQ8GAAAAb1BMVEUAAADV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dUFO9ljAAAAJHRSTlMA7hHwDh7nsBfy2Ldd4FY9G/jQy72oZ2JRNAWnmY9+dnBLRyjnCDnsAAAArElEQVQoz82S2RLCIBRDoRRs6UY3u7hr/v8bLTA6VQRfm+HtJMMlF3IvEJCsSJADDQGIXzFY2MCNoeM+PgpjAMt/4qQHjGG3nMTlpUB6sTPkFLT8ji+xjL+GVBlwiFZYZ9iwfsU+hbi9sdJx9flM3gHH2PKBgeZuD9caRaWtmR3aLerRAqdYX1Z6mpzPNVKgT/xVTw3EGN4Fn/8ua5uGyC/9oySCakklaUByegKD1h5JT5G7YwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_common/message.png
// module id = Zl4u
// module chunks = 1